/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedNullSearchResults_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "BuySharedNullSearchResults_buyPage";
};
export type BuySharedNullSearchResults_buyPage$data = BuySharedNullSearchResults_buyPage;
export type BuySharedNullSearchResults_buyPage$key = {
    readonly " $data"?: BuySharedNullSearchResults_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedNullSearchResults_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedNullSearchResults_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '97a5d28a908c5e831169aa05b8e1ed96';
export default node;
